import { take, map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable()
export class UserGuard {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}
  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    next: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.userService.getUser().pipe(
      map(user => {
        if (!user) {
          this.router.navigate(['error/401']);
        }
        return true;
      }),
      take(1),
    );
  }
}
